<template>
  <div>
    <dashboard-header :text='$t("ui.groupCaption")'/>
    <v-card
        elevation="0"
        class="card-border-10">

      <d-table
          class="pt-10 px-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :add="isCreate ? addItem : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :placeholder="placeholder"
      />

    </v-card>
  </div>
</template>

<script>
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";
import { PERMISSIONS } from "../../config/permissions";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
      // removed static permissions - moved to computed
    };
  },
  mounted() {
    this.onTab()
  },
  computed: {
    placeholder() {
    return this.$t('ui.groupSearchHolder');
    },
    // Permission computed properties
    isCreate() {
      return this.hasPermission(PERMISSIONS.GROUP_CREATE);
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.GROUP_UPDATE);
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.GROUP_DELETE);
    },
    fields() {
      return [
        {value: "name", text: i18n.t("ui.nameGroup")},
        {value: "numberSchedules", text: i18n.t("ui.numberSchedules"), sortable: false},
        {value: this.isEdit || this.isDelete ? "actions" : null, sortable: false}
      ].filter(field => field.value !== null);
    },
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
    },
    async getItems(optionParams) {
      if (!optionParams) return
      this.optionParams = optionParams
      let res = await this.get(API2.GROUP, optionParams)
      if (!res) return
      this.totalRows = res.total
      this.items = res.data.map(value => {
        return {
          data: {...value, idDetail: value.groupId},
          name: value.name,
          numberSchedules: value.scheduleCount || 0,
        };
      });
    },
    addItem() {
      this.openTab(2)
    },
    editItem(item) {
      this.openTab(2, item)
    },
    onItemTableClick(item) {
      if (!this.checkPermissionOrShowError(PERMISSIONS.GROUP_VIEW, 'Bạn không có quyền xem chi tiết nhóm')) {
        return;
      }
      this.openTab(1, item)
    },
    onDeleteContent() {
      return i18n.t("ui.confirmDataDelGroup")
    },
    async deleteItem(item) {
      let res = await this.delete(API2.GROUP, {path: item.data.groupId})
      if (res) {
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.deleteSuccessful"))
        this.getItems(this.optionParams);
      }
    }
  }
};
</script>

<style></style>
